import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-lista-documentos-proposta',
  templateUrl: './lista-documentos-proposta.component.html',
  styleUrls: ['./lista-documentos-proposta.component.scss'],
})
export class ListaDocumentosPropostaComponent implements OnInit, OnChanges {
  @Input() entidadeProposta: string = '';
  @Input() razaoSocialEntidade: string = '';
  @Input() codigoProposta: string = '';
  @Input() vigenciaProposta: string = '';
  @Input() beneficiariosComDocumentos: any;
  @Input() dadosOperadoraDM!: any;
  operadoraVM!: any;
  @Input() dadosOperadoraCabecalho!: any;
  tipoProdutoEnum = TipoProduto_E_OperadoraEnum;
  constructor() {
    const pdfjsVer = pdfjsLib.version;
    (pdfjsLib as any).GlobalWorkerOptions.workerSrc =
      `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsVer}/pdf.worker.min.js`;
  }

  async ngOnInit(): Promise<void> {
    this.operadoraVM = this.carregarDadosOperadora();
  }

  async ngOnChanges(changes: SimpleChanges) {
    // Detecta quando os beneficiários chegam ou mudam
    if (changes['beneficiariosComDocumentos'] && this.beneficiariosComDocumentos?.length > 0) {
      await this.processarDocumentosPdf();
    }
  }

  isOdonto(): boolean {
    const tipoProduto = this.dadosOperadoraDM?.productType || this.dadosOperadoraCabecalho?.tipoProduto;
    return TipoProduto_E_OperadoraComponent.isOdonto(tipoProduto);
  }

  carregarDadosOperadora(): string {
    const cnpjOperadoraFiltro = this.dadosOperadoraDM?.operatorObject && this.dadosOperadoraDM?.operatorObject?.cnpj;
    if (!cnpjOperadoraFiltro) {
      return '../../../../../../assets/app-assets/images/logos-empresas/default.png';
    }
    // Busca os dados da operadora pelo CNPJ
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    // Retorna o logo dos dados ou um padrão
    return dadosOperadora;
  }

  isImage(filePath: string): boolean {
    return !!filePath && /\.(jpg|jpeg|png|gif)$/i.test(filePath);
  }

  isPdf(filePath: string): boolean {
    return !!filePath && filePath.toLowerCase().endsWith('.pdf');
  }

  async processarDocumentosPdf() {
    for (const beneficiario of this.beneficiariosComDocumentos) {
      if (beneficiario.documentos) {
        for (const doc of beneficiario.documentos) {
          // Só converte se ainda não foi convertido e se for PDF
          if (this.isPdf(doc.filePath) && !doc.paginasImagens) {
            doc.carregando = true; // Flag para o HTML
            doc.paginasImagens = await this.convertPdfToImages(doc.filePath);
            doc.carregando = false;
          }
        }
      }
    }
  }

  async convertPdfToImages(pdfUrl: string): Promise<string[]> {
    try {
      // Adicionamos parâmetros para garantir que o PDF.js tente ler o arquivo corretamente
      const loadingTask = pdfjsLib.getDocument({
        url: pdfUrl,
        disableAutoFetch: false,
        disableStream: false,
      });

      const pdf = await loadingTask.promise;
      const images: string[] = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        // Scale 3.0 para impressão de alta fidelidade
        const viewport = page.getViewport({scale: 3.0});

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        if (context) {
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({
            canvasContext: context,
            viewport: viewport,
          }).promise;

          images.push(canvas.toDataURL('image/jpeg', 1.0));
        }
      }
      return images;
    } catch (error) {
      console.error('Erro ao renderizar PDF:', error);
      return [];
    }
  }
}
